(function () {
  const DESKTOP_BREAKPOINT = 1200;

  function initProductTabs() {
    const tabGroups = document.querySelectorAll(
      '.armatura-product-redesign [data-armatura-product-tabs]'
    );

    tabGroups.forEach((group) => {
      if (group.dataset.armaturaTabsInitialized === 'true') {
        return;
      }

      const items = Array.from(
        group.querySelectorAll(':scope > .product-block--tab')
      );

      /* Define automáticamente cuántas columnas debe tener el grupo */
      group.style.setProperty('--armatura-tab-count', items.length);

      if (items.length < 2) {
        return;
      }

      const buttons = items
        .map((item) => item.querySelector('.collapsible-trigger'))
        .filter(Boolean);

      const panels = items
        .map((item) => item.querySelector('.collapsible-content'))
        .filter(Boolean);

      if (
        buttons.length !== items.length ||
        panels.length !== items.length
      ) {
        return;
      }

      group.dataset.armaturaTabsInitialized = 'true';

      function activateDesktopTab(activeIndex) {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
          return;
        }

        items.forEach((item, index) => {
          const button = buttons[index];
          const panel = panels[index];
          const isActive = index === activeIndex;

          item.classList.toggle('armatura-tab--active', isActive);

        button.classList.toggle('armatura-tab-trigger--active', isActive);
        button.classList.toggle('is-open', isActive);
        button.setAttribute('aria-expanded', String(isActive));

        panel.classList.toggle('armatura-tab-panel--active', isActive);
        panel.classList.toggle('is-open', isActive);

        if (isActive) {
            panel.style.height = 'auto';
            panel.style.overflow = 'visible';
            panel.style.opacity = '1';
            panel.style.visibility = 'visible';
        } else {
            panel.style.height = '0px';
            panel.style.overflow = 'hidden';
            panel.style.opacity = '0';
            panel.style.visibility = 'hidden';
        }
        });
      }

      function restoreMobileAccordion() {
        items.forEach((item, index) => {
          const button = buttons[index];
          const panel = panels[index];

          item.classList.remove('armatura-tab--active');
          button.classList.remove('armatura-tab-trigger--active');
          panel.classList.remove('armatura-tab-panel--active');

          button.classList.remove('is-open');
          panel.classList.remove('is-open');

          panel.style.removeProperty('overflow');
          panel.style.removeProperty('opacity');
          panel.style.removeProperty('visibility');

          if (button.getAttribute('aria-expanded') !== 'true') {
            panel.style.height = '0px';
          }
        });
      }

      buttons.forEach((button, index) => {
        button.addEventListener('click', function (event) {
          if (window.innerWidth < DESKTOP_BREAKPOINT) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          activateDesktopTab(index);
        });
      });

      function applyResponsiveMode() {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
          const activeIndex = items.findIndex((item) =>
            item.classList.contains('armatura-tab--active')
          );

          activateDesktopTab(activeIndex >= 0 ? activeIndex : 0);
        } else {
          restoreMobileAccordion();
        }
      }

      applyResponsiveMode();

      window.addEventListener('resize', applyResponsiveMode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  document.addEventListener('shopify:section:load', initProductTabs);
})();

/* =========================================================
   PDP ARMATURA — STICKY SEGÚN COLUMNA MÁS CORTA
   Desktop con galería editorial
========================================================= */

(() => {
  const DESKTOP_BREAKPOINT = 1200;
  const HEIGHT_DIFFERENCE = 40;

  function updateArmaturaColumnSticky(productSection) {
    if (!productSection) return;

    const layout = productSection.querySelector(
      ".grid--product-images--partial"
    );

    const galleryColumn = productSection.querySelector(
      ".grid__item.medium-up--three-fifths"
    );

    const infoColumn = productSection.querySelector(
      ".grid__item.medium-up--two-fifths"
    );

    const editorialGallery = productSection.querySelector(
      "[data-armatura-editorial-gallery]"
    );

    if (
      !layout ||
      !galleryColumn ||
      !infoColumn ||
      !editorialGallery
    ) {
      return;
    }

    const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

    const editorialIsVisible =
      window.getComputedStyle(editorialGallery).display !== "none";

    if (!isDesktop || !editorialIsVisible) {
      layout.classList.remove(
        "armatura-gallery-taller",
        "armatura-info-taller"
      );
      return;
    }

    /*
      scrollHeight refleja la altura completa de cada columna.
      Esto es más fiable que getBoundingClientRect cuando ya
      existen reglas sticky activas.
    */
    const galleryHeight = galleryColumn.scrollHeight;
    const infoHeight = infoColumn.scrollHeight;

    const galleryIsTaller =
      galleryHeight > infoHeight + HEIGHT_DIFFERENCE;

    const infoIsTaller =
      infoHeight > galleryHeight + HEIGHT_DIFFERENCE;

    layout.classList.toggle(
      "armatura-gallery-taller",
      galleryIsTaller
    );

    layout.classList.toggle(
      "armatura-info-taller",
      infoIsTaller
    );
  }

  function initializeArmaturaColumnSticky() {
    const productSections = document.querySelectorAll(
      ".armatura-product-redesign.armatura-gallery-grid-active"
    );

    productSections.forEach((productSection) => {
      const update = () => {
        updateArmaturaColumnSticky(productSection);
      };

      update();

      const galleryColumn = productSection.querySelector(
        ".grid__item.medium-up--three-fifths"
      );

      const infoColumn = productSection.querySelector(
        ".grid__item.medium-up--two-fifths"
      );

      if (
        "ResizeObserver" in window &&
        galleryColumn &&
        infoColumn
      ) {
        const resizeObserver = new ResizeObserver(update);

        resizeObserver.observe(galleryColumn);
        resizeObserver.observe(infoColumn);
      }

      productSection
        .querySelectorAll("img, video")
        .forEach((media) => {
          media.addEventListener("load", update);
          media.addEventListener("loadedmetadata", update);
        });
    });
  }

  let armaturaStickyResizeTimer;

  window.addEventListener("resize", () => {
    clearTimeout(armaturaStickyResizeTimer);

    armaturaStickyResizeTimer = setTimeout(() => {
      document
        .querySelectorAll(
          ".armatura-product-redesign.armatura-gallery-grid-active"
        )
        .forEach(updateArmaturaColumnSticky);
    }, 150);
  });

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeArmaturaColumnSticky
    );
  } else {
    initializeArmaturaColumnSticky();
  }
})();

/* =========================================================
   GALERÍA DE PRODUCTO — LIGHTBOX ARMATURA
   PC: imagen completa + lupa localizada
   Tablet/celular: imagen completa + pinch-to-zoom + arrastre
========================================================= */

(() => {
  const DESKTOP_BREAKPOINT = 1200;
  const LENS_ZOOM = 2.5;
  const MOBILE_MAX_ZOOM = 4;

  let lightbox = null;
  let lightboxImage = null;
  let lightboxLens = null;
  let lightboxStage = null;
  let counter = null;

  let images = [];
  let currentIndex = 0;
  let lastFocusedElement = null;

  /* Estado táctil */
  let mobileScale = 1;
  let mobileTranslateX = 0;
  let mobileTranslateY = 0;

  let initialPinchDistance = 0;
  let initialPinchScale = 1;

  let dragStartX = 0;
  let dragStartY = 0;
  let dragOriginX = 0;
  let dragOriginY = 0;


  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function supportsMouseLens() {
    return (
      isDesktop() &&
      window.matchMedia(
        "(hover: hover) and (pointer: fine)"
      ).matches
    );
  }

  function getTouchDistance(touchA, touchB) {
    return Math.hypot(
      touchB.clientX - touchA.clientX,
      touchB.clientY - touchA.clientY
    );
  }

  /* =======================================================
     LUPA DE PC
  ======================================================= */

  function hideLens() {
    if (!lightboxLens) return;

    lightboxLens.classList.remove("is-visible");
    lightboxLens.style.backgroundImage = "";
    lightboxLens.style.backgroundSize = "";
    lightboxLens.style.backgroundPosition = "";
  }

  function updateLens(event) {
    if (
      !supportsMouseLens() ||
      !lightboxImage ||
      !lightboxLens ||
      !lightboxStage
    ) {
      return;
    }

    const imageRect =
      lightboxImage.getBoundingClientRect();

    const stageRect =
      lightboxStage.getBoundingClientRect();

    const cursorX =
      event.clientX - imageRect.left;

    const cursorY =
      event.clientY - imageRect.top;

    const cursorIsInsideImage =
      cursorX >= 0 &&
      cursorY >= 0 &&
      cursorX <= imageRect.width &&
      cursorY <= imageRect.height;

    if (!cursorIsInsideImage) {
      hideLens();
      return;
    }

    const lensWidth =
      lightboxLens.offsetWidth;

    const lensHeight =
      lightboxLens.offsetHeight;

    let lensLeft =
      imageRect.left -
      stageRect.left +
      cursorX -
      lensWidth / 2;

    let lensTop =
      imageRect.top -
      stageRect.top +
      cursorY -
      lensHeight / 2;

    const minimumLeft =
      imageRect.left - stageRect.left;

    const minimumTop =
      imageRect.top - stageRect.top;

    const maximumLeft =
      minimumLeft +
      imageRect.width -
      lensWidth;

    const maximumTop =
      minimumTop +
      imageRect.height -
      lensHeight;

    if (maximumLeft < minimumLeft) {
      lensLeft =
        minimumLeft +
        (imageRect.width - lensWidth) / 2;
    } else {
      lensLeft = Math.min(
        maximumLeft,
        Math.max(minimumLeft, lensLeft)
      );
    }

    if (maximumTop < minimumTop) {
      lensTop =
        minimumTop +
        (imageRect.height - lensHeight) / 2;
    } else {
      lensTop = Math.min(
        maximumTop,
        Math.max(minimumTop, lensTop)
      );
    }

    const cursorPositionInLensX =
      event.clientX -
      stageRect.left -
      lensLeft;

    const cursorPositionInLensY =
      event.clientY -
      stageRect.top -
      lensTop;

    const magnifiedWidth =
      imageRect.width * LENS_ZOOM;

    const magnifiedHeight =
      imageRect.height * LENS_ZOOM;

    const backgroundX =
      cursorPositionInLensX -
      cursorX * LENS_ZOOM;

    const backgroundY =
      cursorPositionInLensY -
      cursorY * LENS_ZOOM;

    lightboxLens.style.left =
      `${lensLeft}px`;

    lightboxLens.style.top =
      `${lensTop}px`;

    lightboxLens.style.backgroundImage =
      `url("${lightboxImage.currentSrc || lightboxImage.src}")`;

    lightboxLens.style.backgroundSize =
      `${magnifiedWidth}px ${magnifiedHeight}px`;

    lightboxLens.style.backgroundPosition =
      `${backgroundX}px ${backgroundY}px`;

    lightboxLens.classList.add("is-visible");
  }

  /* =======================================================
     ZOOM TÁCTIL
  ======================================================= */

  function clampMobileTranslation() {
    if (
      !lightboxImage ||
      !lightboxStage ||
      mobileScale <= 1
    ) {
      mobileTranslateX = 0;
      mobileTranslateY = 0;
      return;
    }

    const imageWidth =
      lightboxImage.clientWidth;

    const imageHeight =
      lightboxImage.clientHeight;

    const stageWidth =
      lightboxStage.clientWidth;

    const stageHeight =
      lightboxStage.clientHeight;

    const scaledWidth =
      imageWidth * mobileScale;

    const scaledHeight =
      imageHeight * mobileScale;

    const maximumX = Math.max(
      0,
      (scaledWidth - stageWidth) / 2
    );

    const maximumY = Math.max(
      0,
      (scaledHeight - stageHeight) / 2
    );

    mobileTranslateX = Math.min(
      maximumX,
      Math.max(-maximumX, mobileTranslateX)
    );

    mobileTranslateY = Math.min(
      maximumY,
      Math.max(-maximumY, mobileTranslateY)
    );
  }

  function applyMobileTransform({
    animate = false
  } = {}) {
    if (!lightboxImage) return;

    clampMobileTranslation();

    lightboxImage.classList.toggle(
      "is-mobile-zoomed",
      mobileScale > 1
    );

    lightboxImage.classList.toggle(
      "is-resetting",
      animate
    );

    lightboxImage.style.setProperty(
      "--armatura-mobile-transform",
      `translate3d(${mobileTranslateX}px, ${mobileTranslateY}px, 0) scale(${mobileScale})`
    );

    if (animate) {
      window.setTimeout(() => {
        lightboxImage?.classList.remove(
          "is-resetting"
        );
      }, 220);
    }
  }

  function resetMobileZoom({
    animate = false
  } = {}) {
    mobileScale = 1;
    mobileTranslateX = 0;
    mobileTranslateY = 0;

    initialPinchDistance = 0;
    initialPinchScale = 1;

    applyMobileTransform({ animate });
  }

  function handleTouchStart(event) {
    if (isDesktop()) return;

    if (event.touches.length === 2) {
      event.preventDefault();

      initialPinchDistance =
        getTouchDistance(
          event.touches[0],
          event.touches[1]
        );

      initialPinchScale = mobileScale;
      return;
    }

    if (
      event.touches.length === 1 &&
      mobileScale > 1
    ) {
      event.preventDefault();

      dragStartX =
        event.touches[0].clientX;

      dragStartY =
        event.touches[0].clientY;

      dragOriginX = mobileTranslateX;
      dragOriginY = mobileTranslateY;
    }
  }

  function handleTouchMove(event) {
    if (isDesktop()) return;

    if (
      event.touches.length === 2 &&
      initialPinchDistance > 0
    ) {
      event.preventDefault();

      const currentDistance =
        getTouchDistance(
          event.touches[0],
          event.touches[1]
        );

      const nextScale =
        initialPinchScale *
        (currentDistance /
          initialPinchDistance);

      mobileScale = Math.min(
        MOBILE_MAX_ZOOM,
        Math.max(1, nextScale)
      );

      if (mobileScale === 1) {
        mobileTranslateX = 0;
        mobileTranslateY = 0;
      }

      applyMobileTransform();
      return;
    }

    if (
      event.touches.length === 1 &&
      mobileScale > 1
    ) {
      event.preventDefault();

      mobileTranslateX =
        dragOriginX +
        event.touches[0].clientX -
        dragStartX;

      mobileTranslateY =
        dragOriginY +
        event.touches[0].clientY -
        dragStartY;

      applyMobileTransform();
    }
  }

  function handleTouchEnd(event) {
    if (isDesktop()) return;

    if (event.touches.length < 2) {
      initialPinchDistance = 0;
      initialPinchScale = mobileScale;
    }

    if (mobileScale < 1.05) {
      resetMobileZoom({
        animate: true
      });
    } else {
      applyMobileTransform({
        animate: true
      });
    }
  }


  /* =======================================================
     CREAR LIGHTBOX
  ======================================================= */

  function createLightbox() {
    const existingLightbox =
      document.querySelector(
        "[data-armatura-lightbox]"
      );

    if (existingLightbox) {
      existingLightbox.remove();
    }

    lightbox = document.createElement("div");
    lightbox.className =
      "armatura-lightbox";

    lightbox.setAttribute(
      "data-armatura-lightbox",
      ""
    );

    lightbox.setAttribute(
      "aria-hidden",
      "true"
    );

    lightbox.innerHTML = `
      <div
        class="armatura-lightbox__backdrop"
        data-lightbox-close
      ></div>

      <div
        class="armatura-lightbox__dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Vista ampliada del producto"
      >
        <div class="armatura-lightbox__topbar">
          <span
            class="armatura-lightbox__counter"
            data-lightbox-counter
            aria-live="polite"
          ></span>

          <div class="armatura-lightbox__controls">
            <span class="armatura-lightbox__hint armatura-lightbox__hint--desktop">
              Mueve la lupa sobre la imagen
            </span>

            <span class="armatura-lightbox__hint armatura-lightbox__hint--touch">
              Pellizca para ampliar
            </span>

            <button
              type="button"
              class="armatura-lightbox__close"
              data-lightbox-close
              aria-label="Cerrar imagen"
            >
              ×
            </button>
          </div>
        </div>

        <button
          type="button"
          class="armatura-lightbox__arrow armatura-lightbox__arrow--previous"
          data-lightbox-previous
          aria-label="Imagen anterior"
        >
          ‹
        </button>

        <div
          class="armatura-lightbox__stage"
          data-lightbox-stage
        >
          <img
            class="armatura-lightbox__image"
            data-lightbox-image
            alt=""
            draggable="false"
          >

          <div
            class="armatura-lightbox__lens"
            data-lightbox-lens
            aria-hidden="true"
          ></div>
        </div>

        <button
          type="button"
          class="armatura-lightbox__arrow armatura-lightbox__arrow--next"
          data-lightbox-next
          aria-label="Imagen siguiente"
        >
          ›
        </button>
      </div>
    `;

    document.body.appendChild(lightbox);

    lightboxImage = lightbox.querySelector(
      "[data-lightbox-image]"
    );

    lightboxLens = lightbox.querySelector(
      "[data-lightbox-lens]"
    );

    lightboxStage = lightbox.querySelector(
      "[data-lightbox-stage]"
    );

    counter = lightbox.querySelector(
      "[data-lightbox-counter]"
    );

    const dialog = lightbox.querySelector(
      ".armatura-lightbox__dialog"
    );

    const previousButton =
      lightbox.querySelector(
        "[data-lightbox-previous]"
      );

    const nextButton =
      lightbox.querySelector(
        "[data-lightbox-next]"
      );

    lightbox
      .querySelectorAll(
        "[data-lightbox-close]"
      )
      .forEach((element) => {
        element.addEventListener(
          "click",
          closeLightbox
        );
      });

    previousButton.addEventListener(
      "click",
      (event) => {
        event.stopPropagation();
        showImage(currentIndex - 1);
      }
    );

    nextButton.addEventListener(
      "click",
      (event) => {
        event.stopPropagation();
        showImage(currentIndex + 1);
      }
    );

    /* Lupa de PC */
    lightboxImage.addEventListener(
      "mouseenter",
      updateLens
    );

    lightboxImage.addEventListener(
      "mousemove",
      updateLens
    );

    lightboxImage.addEventListener(
      "mouseleave",
      hideLens
    );

    /* Gestos táctiles */
    lightboxStage.addEventListener(
      "touchstart",
      handleTouchStart,
      { passive: false }
    );

    lightboxStage.addEventListener(
      "touchmove",
      handleTouchMove,
      { passive: false }
    );

    lightboxStage.addEventListener(
      "touchend",
      handleTouchEnd,
      { passive: false }
    );

    /*
      Cerrar al tocar fuera de la imagen,
      salvo botones de navegación.
    */
    dialog.addEventListener(
      "click",
      (event) => {
        const clickedImage =
          event.target.closest(
            "[data-lightbox-image]"
          );

        const clickedButton =
          event.target.closest("button");

        if (
          !clickedImage &&
          !clickedButton
        ) {
          closeLightbox();
        }
      }
    );

    lightboxImage.addEventListener(
      "click",
      (event) => {
        event.stopPropagation();
      }
    );

    document.addEventListener(
      "keydown",
      handleKeyboard
    );
  }

  /* =======================================================
     DATOS DE LAS GALERÍAS
  ======================================================= */

  function collectEditorialImages(
    editorialGallery
  ) {
    return Array.from(
      editorialGallery.querySelectorAll(
        '[data-armatura-editorial-item][data-media-type="image"] img'
      )
    )
      .map((image) => ({
        src:
          image.currentSrc ||
          image.getAttribute("src") ||
          "",
        alt:
          image.getAttribute("alt") ||
          "Imagen del producto"
      }))
      .filter((image) => image.src);
  }

  function collectOriginalGalleryImages(
    productImages
  ) {
    return Array.from(
      productImages.querySelectorAll(
        ".product-main-slide"
      )
    )
      .map((slide) => {
        const image =
          slide.querySelector("img");

        if (!image) return null;

        return {
          slide,
          src:
            image.getAttribute(
              "data-photoswipe-src"
            ) ||
            image.currentSrc ||
            image.getAttribute("src") ||
            "",
          alt:
            image.getAttribute("alt") ||
            "Imagen del producto"
        };
      })
      .filter(
        (item) =>
          item &&
          item.src
      );
  }

  /* =======================================================
     MOSTRAR / ABRIR / CERRAR
  ======================================================= */

  function showImage(index) {
    if (
      !lightboxImage ||
      !counter ||
      images.length === 0
    ) {
      return;
    }

    currentIndex =
      (index + images.length) %
      images.length;

    hideLens();
    resetMobileZoom();

    const selectedImage =
      images[currentIndex];

    lightboxImage.src =
      selectedImage.src;

    lightboxImage.alt =
      selectedImage.alt;

    counter.textContent =
      `${currentIndex + 1} / ${images.length}`;

    const hideNavigation =
      images.length <= 1;

    lightbox.classList.toggle(
      "has-single-image",
      hideNavigation
    );
  }

  function activateLightbox(selectedIndex) {
    if (!images.length) return;

    lastFocusedElement =
      document.activeElement;

    createLightbox();
    showImage(selectedIndex);

    lightbox.classList.add("is-open");

    lightbox.setAttribute(
      "aria-hidden",
      "false"
    );

    lightbox.classList.toggle(
      "is-desktop-mode",
      isDesktop()
    );

    lightbox.classList.toggle(
      "is-touch-mode",
      !isDesktop()
    );

    document.documentElement.classList.add(
      "armatura-lightbox-open"
    );

    const closeButton =
      lightbox.querySelector(
        ".armatura-lightbox__close"
      );

    closeButton?.focus();
  }

  function openEditorialLightbox(
    editorialItem
  ) {
    if (!isDesktop()) return;

    const editorialGallery =
      editorialItem.closest(
        "[data-armatura-editorial-gallery]"
      );

    if (!editorialGallery) return;

    const imageItems = Array.from(
      editorialGallery.querySelectorAll(
        '[data-armatura-editorial-item][data-media-type="image"]'
      )
    );

    const selectedIndex =
      imageItems.indexOf(editorialItem);

    if (selectedIndex < 0) return;

    images =
      collectEditorialImages(
        editorialGallery
      );

    activateLightbox(selectedIndex);
  }

  function openOriginalGalleryLightbox(
    productImages,
    selectedSlide
  ) {
    const originalImages =
      collectOriginalGalleryImages(
        productImages
      );

    if (!originalImages.length) return;

    /*
      En PC solo se usa la galería original
      cuando existen de 1 a 3 imágenes.

      En tablet/celular se permite cualquier
      cantidad porque la galería editorial
      no se muestra allí.
    */
    if (
      isDesktop() &&
      originalImages.length > 3
    ) {
      return;
    }

    const selectedIndex =
      originalImages.findIndex(
        (item) =>
          item.slide === selectedSlide
      );

    images = originalImages.map(
      (item) => ({
        src: item.src,
        alt: item.alt
      })
    );

    activateLightbox(
      selectedIndex >= 0
        ? selectedIndex
        : 0
    );
  }

  function closeLightbox() {
    if (
      !lightbox ||
      !lightbox.classList.contains(
        "is-open"
      )
    ) {
      return;
    }

    hideLens();
    resetMobileZoom();

    lightbox.classList.remove("is-open");

    lightbox.setAttribute(
      "aria-hidden",
      "true"
    );

    document.documentElement.classList.remove(
      "armatura-lightbox-open"
    );

    window.setTimeout(() => {
      if (
        lightboxImage &&
        !lightbox.classList.contains(
          "is-open"
        )
      ) {
        lightboxImage.removeAttribute("src");
      }
    }, 200);

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        "function"
    ) {
      lastFocusedElement.focus();
    }
  }

  function handleKeyboard(event) {
    if (
      !lightbox ||
      !lightbox.classList.contains(
        "is-open"
      )
    ) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeLightbox();
      return;
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      showImage(currentIndex - 1);
      return;
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      showImage(currentIndex + 1);
    }
  }

  /* =======================================================
     INICIALIZACIÓN
  ======================================================= */

  function initializeEditorialLightbox() {
    document
      .querySelectorAll(
        '.armatura-product-redesign [data-armatura-editorial-item][data-media-type="image"]'
      )
      .forEach((editorialItem) => {
        if (
          editorialItem.dataset
            .armaturaLightboxInitialized ===
          "true"
        ) {
          return;
        }

        editorialItem.dataset
          .armaturaLightboxInitialized =
          "true";

        editorialItem.classList.add(
          "armatura-editorial-gallery__item--zoomable"
        );

        editorialItem.setAttribute(
          "role",
          "button"
        );

        editorialItem.setAttribute(
          "tabindex",
          "0"
        );

        editorialItem.setAttribute(
          "aria-label",
          "Abrir imagen completa del producto"
        );

        editorialItem.addEventListener(
          "click",
          () => {
            openEditorialLightbox(
              editorialItem
            );
          }
        );

        editorialItem.addEventListener(
          "keydown",
          (event) => {
            if (
              event.key !== "Enter" &&
              event.key !== " "
            ) {
              return;
            }

            event.preventDefault();

            openEditorialLightbox(
              editorialItem
            );
          }
        );
      });
  }

  function initializeOriginalGalleryLightbox() {
    document
      .querySelectorAll(
        ".armatura-product-redesign [data-product-images]"
      )
      .forEach((productImages) => {
        if (
          productImages.dataset
            .armaturaOriginalLightboxInitialized ===
          "true"
        ) {
          return;
        }

        const originalImages =
          collectOriginalGalleryImages(
            productImages
          );

        if (!originalImages.length) {
          return;
        }

        productImages.dataset
          .armaturaOriginalLightboxInitialized =
          "true";

        if (originalImages.length <= 3) {
          productImages.classList.add(
            "armatura-original-three-lightbox-ready"
          );
        }

        /*
          Captura el clic antes de PhotoSwipe
          para impedir el zoom automático viejo.
        */
        productImages.addEventListener(
          "click",
          (event) => {
            const selectedSlide =
              event.target.closest(
                ".product-main-slide"
              );

            if (!selectedSlide) return;

            const clickedImage =
              event.target.closest(
                ".product-image-main"
              );

            const clickedZoomButton =
              event.target.closest(
                ".js-photoswipe__zoom"
              );

            if (
              !clickedImage &&
              !clickedZoomButton
            ) {
              return;
            }

            /*
              En desktop con 4+ imágenes,
              la galería editorial se encarga.
            */
            if (
              isDesktop() &&
              originalImages.length > 3
            ) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            openOriginalGalleryLightbox(
              productImages,
              selectedSlide
            );
          },
          true
        );
      });
  }

  function initializeAllArmaturaLightboxes() {
    initializeEditorialLightbox();
    initializeOriginalGalleryLightbox();
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAllArmaturaLightboxes
    );
  } else {
    initializeAllArmaturaLightboxes();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeAllArmaturaLightboxes
  );

  window.addEventListener(
    "resize",
    () => {
      hideLens();

      if (
        lightbox?.classList.contains(
          "is-open"
        )
      ) {
        resetMobileZoom();

        lightbox.classList.toggle(
          "is-desktop-mode",
          isDesktop()
        );

        lightbox.classList.toggle(
          "is-touch-mode",
          !isDesktop()
        );
      }
    }
  );
})();